import type { VariableHygieneReport } from '@core/entities/VariableHygiene';
import type { VariableHygieneRepository } from '@core/repositories/VariableHygieneRepository';
import { httpClient } from '@infrastructure/http/httpClient';
import { toAppError } from '@infrastructure/http/errorMapper';

interface VariableHygieneEntryResponse {
  scope: 'global' | 'environment' | 'collection';
  scope_label: string;
  key: string;
  is_enabled: boolean;
  is_unused: boolean;
  also_defined_in: string[];
}

interface VariableHygieneResponse {
  entries: VariableHygieneEntryResponse[];
  resolved_preview: Record<string, { value: string | null; source: string }>;
}

export class VariableHygieneRepositoryImpl implements VariableHygieneRepository {
  async analyze(workspaceId: string): Promise<VariableHygieneReport> {
    try {
      const response = await httpClient.get<{ data: VariableHygieneResponse }>(
        `/workspaces/${workspaceId}/variables/hygiene`,
      );
      const { entries, resolved_preview } = response.data.data;

      return {
        entries: entries.map((entry) => ({
          scope: entry.scope,
          scopeLabel: entry.scope_label,
          key: entry.key,
          isEnabled: entry.is_enabled,
          isUnused: entry.is_unused,
          alsoDefinedIn: entry.also_defined_in,
        })),
        resolvedPreview: resolved_preview,
      };
    } catch (error) {
      throw toAppError(error);
    }
  }
}
